import { images } from "../../../../assets/images";
const {User} =images
export const data = [
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },

    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
    {
      name: "Yash Porwal",
      company: "Avasify",
      position: "Product",
      image: User,
      review:
        "This is a customer quote. The customer is going to share their opinion about our product or service, hopefully it’s going to be a positive one. The social proof section is important when you want to increase trust and trustworthiness of your company.",
    },
  ];